import { Button, CreateButton, List, useTranslate } from 'react-admin';
import { PermissionGuard } from 'src/routes/components/permission-guard';
import { DashboardContent } from '../../../../../layouts/dashboard';
import ErrorPage403 from 'src/pages/error/403';
import { CustomBreadcrumbs } from 'src/components/custom-breadcrumbs/custom-breadcrumbs';
import { Resources } from '../../resource';
import { FeeManagementForm } from './FeeManagementForm';
import { ReactElement, useState } from 'react';
import { Stack } from '@mui/material';
import { Iconify } from 'src/components/iconify';
import AuditLogDialog from 'src/pages/admin/components/AuditLog/AuditLogDialog';

const View = () => {
  const [popup, setPopup] = useState<ReactElement>();
  const translate = useTranslate();
  const [auditLogOpen, setAuditLogOpen] = useState(false);
  const [auditTitle, setAuditTitle] = useState('Audit Logs');
  const [selectedRecord, setSelectedRecord] = useState<any>(null);

  return (
    <PermissionGuard resource="fee-management" action="read" fallback={<ErrorPage403 />}>
      <DashboardContent>
        <CustomBreadcrumbs heading={translate('resource.feeManagementScreen')} 
          action={
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              alignItems={{ xs: 'stretch', sm: 'center' }}
              spacing={2}
              mb={1}
            >
              <PermissionGuard resource="audit-logs" action="read" fallback={<></>}>
                <Button
                  variant="contained"
                  size="medium"
                  color="secondary"
                  onClick={() => {
                    setSelectedRecord({});
                    setAuditTitle(`${translate('resource.auditLogs')} - ${translate('resource.feeManagementScreen')}`);
                    setAuditLogOpen(true);
                  }}
                  label={translate('resource.auditLogs')}
                >
                  <Iconify icon="ph:note" />
                </Button>
              </PermissionGuard>
            </Stack>
          }
        />
        <FeeManagementForm></FeeManagementForm>
        <AuditLogDialog
          open={auditLogOpen}
          onClose={() => setAuditLogOpen(false)}
          recordId={selectedRecord?.id}
          resource={Resources.feeManagement}
          title={auditTitle}
        />
      </DashboardContent>
    </PermissionGuard>
  );
};

export default View;
